import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_STORE_OFFER_BY_ID } from "../../../../../queries/v3/queries/get-store-offer-by-id.js";
import { fromStoreOfferByIdQueryToStore } from "../../../adapters/v3/hooks/api/adapters/fromStoreOfferByIdQueryToStore.js";
const useStoreOfferById = (variables) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(
    GET_STORE_OFFER_BY_ID,
    {
      variables,
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      }
    }
  );
  const data = React.useMemo(() => {
    return queryState.data?.store ? fromStoreOfferByIdQueryToStore(queryState.data.store) : null;
  }, [queryState]);
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data
      }
    ],
    [data, queryState, query]
  );
};
export {
  useStoreOfferById as default
};
//# sourceMappingURL=use-store-offer-by-id.js.map
